import React from 'react';
import { getSiteDomain } from '../utils/domain.js';
import './RegistrationSuccess.css';

const themes = {
    'penzi-halisi.com': { key: 'penzi', name: 'Penzi Halisi', logo: '/assets/img/phlogo.jpeg', tagline: 'Genuine connections' },
    'upendo-halisi.com': { key: 'upendo', name: 'Upendo Halisi', logo: '/assets/img/uhlogo.jpeg', tagline: 'Meet someone worth knowing' },
    'expatelitesingles.com': { key: 'expat', name: 'Expat Elite Singles', logo: '/assets/img/logo.jpeg', tagline: 'Intentional introductions' },
};

export default function RegistrationSuccess() {
    const theme = themes[getSiteDomain()] || themes['expatelitesingles.com'];
    return (
        <main className={`registration-success registration-success--${theme.key}`} aria-labelledby="registration-success-title">
            <section className="registration-success-card">
                <div className="registration-success-brand">
                    <img src={theme.logo} alt={`${theme.name} logo`} />
                    <div><p className="registration-success-tagline">{theme.tagline}</p><p className="registration-success-brand-name">{theme.name}</p></div>
                </div>
                <div className="registration-success-divider" />
                <div className="registration-success-check" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="m5 12 4 4L19 6" strokeLinecap="round" strokeLinejoin="round" /></svg>
                </div>
                <p className="registration-success-eyebrow">Registration received</p>
                <h1 id="registration-success-title">Thank you for joining<br /><span>{theme.name}.</span></h1>
                <p className="registration-success-message" role="status">Your account details have been recorded and account will be activated within the next 24 hours.</p>
                <div className="registration-success-status"><span aria-hidden="true" />Awaiting account activation</div>
                <nav className="registration-success-actions" aria-label="After registration">
                    <a href="/" className="registration-success-primary">Back to site</a>
                    <a href="/login" className="registration-success-secondary">Go to login</a>
                </nav>
            </section>
        </main>
    );
}
